<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Insured Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex x12>
          <form>
            <v-expansion-panels>
              <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> Filters
                </div>
              </v-expansion-panel-header>
                <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-md>
                      <v-layout row wrap>
                        <v-flex md6 lg6 xs12>
                          <v-text-field v-model="filters.insdRefNo" :label="filtersLabel.insdRefNo" :error-messages="errors.collect('insdRefNo')" data-vv-name="insdRefNo" :data-vv-as="filtersLabel.insdRefNo" v-validate="'entry|max:8'"></v-text-field>
                        </v-flex>
                        <v-flex md6 lg6 xs12>
                          <v-text-field v-model="filters.name1" :label="filtersLabel.name1" :error-messages="errors.collect('name1')" data-vv-name="name1" :data-vv-as="filtersLabel.name1"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12>
          <v-spacer class="mt-2"></v-spacer>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-flex xs12>
                <v-data-table
                :headers="headers"
                :items="items"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                :loading="loading"
                :server-items-length="totalItems"
                :no-data-text="noDataText"
                item-key="key"
                show-select
                v-bind:options.sync="pagination"
                v-model="selected"
                @input="enterSelectInsured"
                >
                </v-data-table>
              </v-flex>
              <v-flex xs12 v-if="checkedItems.length === 0">
                <div class="small font-weight-light grey--text">Note: Default is "All" if no item is selected. </div>
              </v-flex>
              <v-flex xs12 v-if="checkedItems.length > 0">
                <v-textarea label="Selected Items" v-model="checkedItems" rows="2" readonly></v-textarea>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'insured')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn>
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'insured')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Insured Ref', value: 'insdRefNo' },
        { text: 'Name', value: 'name1' }
      ],
      filters: {
        insdRefNo: null,
        name1: undefined
      },
      filtersLabel: {
        insdRefNo: 'Insured Reference',
        name1: 'Name'
      },
      pagination: {
        page: 1,
        sortDesc: [false]
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit(options) {
      const apiURI = this.menu.getInsdLists
      if (apiURI) {
        const { page, itemsPerPage } = this.pagination
        let expand = {
          page: page - 1,
          size: itemsPerPage,
          options: options
        }
        this.loading = true
        await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc)).then(result => {
          this.items = []
          this.allItems = this.items
          this.selectedItems = []
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            data.map(insdList => {
              const convertList = {
                key: insdList.insdRefNo,
                insdRefNo: insdList.insdRefNo,
                name1: insdList.name1
              }
              if (this.checkedItems.includes(insdList.insdRefNo)) {
                const insuredList = {
                  key: insdList.insdRefNo,
                  insdRefNo: insdList.insdRefNo,
                  name1: insdList.name1
                }
                this.selectedItems.push(insuredList)
              }
              this.items.push(convertList)
            })
          }
          if (this.checkedItems.toString() === 'All') {
            this.doReset()
            this.toggleAll()
          } else {
            this.toggleSelected()
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doClearFilters() {
      this.filters.insdRefNo = null
      this.doInit(false)
    }
  },
  watch: {
    'pagination': async function(value) {
      this.onPagination = true
      await this.doInit(false)
      this.onPagination = false
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    helpListMixin
  ],
  props: {
    'menu': Object
  }
}
</script>

<style>
</style>
